import { render, staticRenderFns } from "./ViewDetails.vue?vue&type=template&id=6ba94bfe&scoped=true"
import script from "./ViewDetails.vue?vue&type=script&lang=js"
export * from "./ViewDetails.vue?vue&type=script&lang=js"
import style0 from "./ViewDetails.vue?vue&type=style&index=0&id=6ba94bfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba94bfe",
  null
  
)

export default component.exports